module.exports = __webpack_public_path__ + "img/sgk.62f2500b.svg";